// src/App.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Select, MenuItem } from '@mui/material';


function TaskList() {

  const companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'));

  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    let companyID = companyInfo.ID;
    axios
      .get('https://portal.peaksoftcon.com:8081/api/tasks', { params: { companyID } })
      .then((response) => setTasks(response.data))
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  // Mapping for integer statuses
  const statusMap = {
    0: "Başlamadı",
    1: "Devam Ediyor",
    2: "Tamamlandı"
  };

  // Handler to change the task status
  const handleStatusChange = (taskId, newStatus) => {
    console.log("its in");
    setTasks((prevTasks) =>
      prevTasks.map((task) =>
        task.ID === taskId ? { ...task, Status: newStatus } : task
      )
    );
  };


  return (

    <div className="col-md-6">
      <div className="p-4 bg-light border">

        <h1>Yapılan İşler</h1>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Görev Adı</TableCell>
                <TableCell>Açıklama</TableCell>
                <TableCell>Durum</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tasks.map((task) => (
                <TableRow key={task.ID}>
                  <TableCell>{task.ID}</TableCell>
                  <TableCell>{task.Task_Name}</TableCell>
                  <TableCell>{task.Task_Description}</TableCell>
                  <TableCell>{statusMap[task.Task_Status]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default TaskList;